(ns common.schema.entities.survey.survey-process-status
  (:require
   [common.util :as cu]))

(def options
  [{:key   :survey-process.status/template
    :ord   0.0
    :label "Template"}
   {:key   :survey-process.status/draft
    :ord   1.0
    :label "Draft"}
   {:key   :survey-process.status/prefilled
    :ord   2.0
    :label "Prefilled"}
   {:key   :survey-process.status/wip
    :ord   3.0
    :label "WIP"}
   {:key   :survey-process.status/submitted
    :ord   4.0
    :label "Reviewing"}
   {:key   :survey-process.status/approved
    :ord   5.0
    :label "Approved"}
   {:key   :survey-process.status/approved-modified
    :ord   6.0
    :label "Revised"}])

(def by-status
  (->> options
       (map (fn [o]
              [(:key o) o]))
       (into {})))

(defn get-option
  [status]
  (get by-status status))

(defn label
  [status]
  (:label (get by-status status)))

(defn next-status
  [status]
  (let [current-opt (get-option status)]
    (->> options
         (remove (fn [opt]
                   (<= (:ord opt) (:ord current-opt))))
         (sort-by :ord)
         (first))))

